// Styled Components
import styled from "styled-components";

const Background = () => {
  return <Wrapper></Wrapper>;
};

export default Background;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  z-index: -100;

  width: 100%;
  height: 100%;

  background: rgb(24, 27, 37);
  background: linear-gradient(
    167deg,
    rgba(24, 27, 37, 1) 0%,
    rgba(21, 24, 34, 1) 15%,
    rgba(35, 38, 58, 1) 36%,
    rgba(61, 89, 110, 1) 87%,
    rgba(74, 112, 133, 1) 100%
  );
`;
